module.exports = __webpack_public_path__ + "img/e5ad2.d9776c58.svg";